<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title>HHS Change</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <section>
        <ion-label v-if="!selectedPerson && isLoggedIn">
          {{ $t('selectPerson') }}
        </ion-label>
        <ion-label v-else-if="!isLoggedIn">
          {{ $t('pleaseLogin') }}
        </ion-label>
        <ion-list v-else>
        <ion-list-header lines="inset">
            <ion-label><h1>Handicap History Sheet</h1></ion-label>
         </ion-list-header>
          <ion-grid v-if="hhsRecord">
            <ion-row>
              <ion-col>
                <div>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>{{ $t('playerName') }}</ion-card-subtitle>
                      <ion-card-title @click="copyToClipboard(hhsRecord.playerName)">{{ hhsRecord.playerName }}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </div>
              </ion-col>
              <ion-col>
                <div>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>{{ $t('playerId') }}</ion-card-subtitle>
                      <ion-card-title @click="copyToClipboard(hhsRecord.playerId)">{{ hhsRecord.playerId }}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </div>
              </ion-col>
              <ion-col>
                <div>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>{{ $t('clubName') }}</ion-card-subtitle>
                      <ion-card-title @click="copyToClipboard(hhsRecord.homeClubName)">{{ hhsRecord.homeClubName }}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </div>
              </ion-col>
              <ion-col>
                <div>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>{{ $t('clubId') }}</ion-card-subtitle>
                      <ion-card-title @click="copyToClipboard(hhsRecord.homeClubId)">{{ hhsRecord.homeClubId }}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </div>
              </ion-col>
              <ion-col>
                <div>
                  <ion-card>
                    <ion-card-header>
                      <ion-card-subtitle>{{ $t('currentHCPI') }}</ion-card-subtitle>
                      <ion-card-title @click="copyToClipboard(hhsRecord.currentHcpi)">{{ Math.round(hhsRecord.currentHcpi * 10) / 10 }}</ion-card-title>
                    </ion-card-header>
                  </ion-card>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-button v-if="!UserData.readonly" expand="full" color="success" @click="savehhsRecord()">Speichern</ion-button>
          
          <!-- Start Column Dropdown -->
          <ion-item v-show="false">
            <ion-label>{{ $t('columnLabel') }}</ion-label>
            <ion-select ref="selectedColumnsDropdown" selectedText=" " multiple="true" :value="enabledColumsChangeHHS" @ionChange="setEnabledColumsChangeHHS($event.target.value)">
              <ion-select-option v-for="(c, i) in columsChangeHHS" :key="i" :value="c.name">{{ $t(c.name) }}</ion-select-option>
            </ion-select>
          </ion-item>
          <!-- End Column Dropdown -->

          <ion-item>
            <ion-label v-for="item in enabledColumsChangeHHS" :key="item"><h3><strong>{{ $t(item) }}</strong></h3></ion-label>
            <ion-chip outline color="primary" @click="openSelectedColumnsDropdown(user)">
              <ion-icon style="height: 50px; margin: 0px;" :icon="reorderFourOutline"></ion-icon>
            </ion-chip>
          </ion-item>
          <ion-item v-for="(sc, i) in hhsRecordItems" :key="i" lines="inset" :color="getColor(sc)">
            <ion-label><h3>{{ i + 1 }} <strong><sup>{{ sc.used_for_hcpi_calc == 1 ? 'X' : '' }}</sup></strong></h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('id')" @click="copyToClipboard(sc.id)"><h3>{{ sc.id }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('date')" @click="copyToClipboard(dayjs(sc.date).format('DD.MM.YYYY'))"><h3>{{ dayjs(sc.date).format('DD.MM.YYYY') }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('courseName')" @click="copyToClipboard(sc.courseName)"><h3>{{ sc.courseName }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('courseId')" @click="copyToClipboard(sc.courseId)"><h3>{{ sc.courseId }}</h3></ion-label>
            <ion-label class="ion-text-wrap" v-if="enabledColumsChangeHHS.includes('tournamentName')" @click="copyToClipboard(sc.tournamentName)"><h3>{{ sc.tournamentName }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('round')" @click="copyToClipboard(sc.round)"><h3>{{ sc.round }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('tournamentId')" @click="copyToClipboard(sc.tournamentId)"><h3>{{ sc.tournamentId }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('par')" @click="copyToClipboard(sc.par)"><h3>{{ sc.par }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('courseRating')" @click="copyToClipboard(sc.courseRating)"><h3>{{ sc.courseRating }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('pcc')" @click="copyToClipboard(sc.pcc)"><h3>{{ sc.pcc }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('slopeRating')" @click="copyToClipboard(sc.slopeRating)"><h3>{{ sc.slopeRating }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('holes')" @click="copyToClipboard(sc.holes)"><h3>{{ sc.holes }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('playForm')" @click="copyToClipboard(sc.playForm)"><h3>{{ sc.playForm }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('adjustedGrossScore')" @click="copyToClipboard(sc.adjustedGrossScore)"><h3>{{ sc.adjustedGrossScore }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('snpv')" @click="copyToClipboard(sc.snpv)"><h3>{{ sc.snpv }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('hcpi')" @click="copyToClipboard(sc.hcpi)"><h3>{{ sc.hcpi }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('playingHcpi')" @click="copyToClipboard(sc.playingHcpi)"><h3>{{ sc.playingHcpi }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('comment')" @click="copyToClipboard(sc.comment)"><h3>{{ sc.comment }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('courseHcpi')" @click="copyToClipboard(sc.courseHcpi)"><h3>{{ sc.courseHcpi }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('resultStatus')" @click="copyToClipboard(sc.resultStatus)"><h3>{{ sc.resultStatus }}</h3></ion-label>
            <ion-label v-if="enabledColumsChangeHHS.includes('country')" @click="copyToClipboard(sc.country)"><h3>{{ sc.country }}</h3></ion-label>

            <ion-chip v-if="!UserData.readonly" outline color="primary" @click="deletehhsRecordItem(sc, i)">
              <ion-icon style="height: 50px; margin: 0px;" :icon="trashOutline"></ion-icon>
            </ion-chip>
          </ion-item>
        </ion-list>
      </section>
    </ion-content>
  </ion-page>
</template>


<script>
import { IonLabel, IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonListHeader,
          IonCardHeader, IonCardContent, IonCard, IonIcon, IonChip, IonList, IonItem, alertController,
          modalController, toastController, loadingController, IonReorder, IonReorderGroup, IonToggle, IonCardSubtitle, IonCardTitle, IonCol, IonRow, IonGrid, IonSelect, IonSelectOption } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { useMutation, useResult, useQuery } from '@vue/apollo-composable'
import { trashOutline, optionsOutline, listOutline, addOutline, reorderFourOutline, closeCircle, saveOutline, helpCircleOutline, refreshOutline } from 'ionicons/icons';
import findhhsRecordByPersonIdQueryFile from '../graphql/findhhsRecordByPersonId.query.gql'
import deletehhsRecordItemMutationFile from '../graphql/deletehhsRecordItem.mutation.gql'

import * as dayjs from 'dayjs';
import Storage from "../plugins/storage.js";
import lodash from 'lodash'
import { Plugins } from '@capacitor/core';
const { Clipboard, Toast } = Plugins;

export default defineComponent({
  name: 'Home',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton, IonLabel, IonCardHeader, IonCardContent, IonCard,IonIcon, IonChip, IonList, IonItem,
    IonListHeader, IonToggle, IonCardSubtitle, IonCardTitle, IonCol, IonRow, IonGrid, IonSelect, IonSelectOption,
    alertController,
    loadingController, 
  },
  setup() {
    const HCPIResetColor = ref("success")

    const { refetch: findhhsRecordByPersonIdRefetch, result: findhhsRecordByPersonIdResult } = useQuery(findhhsRecordByPersonIdQueryFile, {personId: ''})
    const { mutate: deletehhsRecordItemMutation } = useMutation(deletehhsRecordItemMutationFile)

    const asdf = useResult(findhhsRecordByPersonIdResult, null, data => data.findhhsRecordByPersonId.scoringRecordItems)
    let hhsRecordItems = asdf
    const hhsRecord = useResult(findhhsRecordByPersonIdResult, null, data => data.findhhsRecordByPersonId)
    //hhsRecordItems = JSON.parse(JSON.stringify(hhsRecordItems))
    
    let originalhhsRecordItems = [];
    let deletedhhsRecordItems = [];


    return {
      Clipboard, Toast, hhsRecord, hhsRecordItems, findhhsRecordByPersonIdRefetch, closeCircle, saveOutline, helpCircleOutline, refreshOutline,
      addOutline, reorderFourOutline, trashOutline, listOutline, optionsOutline, dayjs, deletehhsRecordItemMutation, originalhhsRecordItems, deletedhhsRecordItems, HCPIResetColor
    }
  },
  watch: {
    '$store.getters.selectedPerson' (val) {
      this.findhhsRecordByPersonIdRefetch({ personId: val.id}).then(res => {
      })
      
    },
  },
  computed: {
    UserData : function(){ return this.$store.getters.UserData},
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
      selectedPerson : function(){
        return this.$store.getters.selectedPerson
      },
      columsChangeHHS : function(){
        return this.$store.getters.columsChangeHHS
      },
      enabledColumsChangeHHS : function(){
        let enabledCols = ['']
        for (const item of this.$store.getters.columsChangeHHS) {
          if (item.selected)
              enabledCols.push(item.name)
        }
        return enabledCols
      },
  },
  methods: {
    refreshPage() {
      this.$router.go()
    },
    openSelectedColumnsDropdown() {
      this.$refs.selectedColumnsDropdown.$el.open()
    },
    copyToClipboard(text) {
      Clipboard.write({string: text })
      Toast.show({
          text: `Copied ${text} to Clipboard`
        })
    },
    getColor(sr) {
      if (sr.status && sr.status == 1) return "dangerlight"
      else if (sr.status && sr.status == 2) return "warninglight"
      else if (sr.status && sr.status == 3) return "successlight"
      return null
    },
    async setEnabledColumsChangeHHS(enabledColumns) {
      const columsChangeHHS = this.$store.getters.columsChangeHHS
      columsChangeHHS.forEach(column => {
        if (enabledColumns.includes(column.name)) {
          column.selected = true
        } else {
          column.selected = false
        }
      })
      this.$store.dispatch('changecolumsChangeHHS', columsChangeHHS)
      //await Storage.setItem('language', language);
    },
    async deletehhsRecordItem(hhsRecordItem, index) {
      // If the status is 1 (deleted) then just set the status to 0 to remove the deleted state
      if (hhsRecordItem.status && hhsRecordItem.status == 1) {
        return hhsRecordItem.status=0
      }

      if (hhsRecordItem.status && hhsRecordItem.status == 3) {
        return this.hhsRecordItem.splice(index, 1)
      }
      else if (hhsRecordItem.status && hhsRecordItem.status == 1)
        return hhsRecordItem.status = 0
      else
        return hhsRecordItem.status=1

    },
    async savehhsRecord() {
      const deletedhhsRecordItems = this.hhsRecordItems.filter(item => item.status == 1);

      const alert = await alertController
        .create({
          header: 'Alert',
          subHeader: 'Subtitle',
          message: `
          Gelöscht:
          <ul>${deletedhhsRecordItems.map(item => `<li>${item.id}</li>`).join(" ")}</ul>
          `,
          buttons: [{
            text: 'Ok',
            handler: async () => {
              const loading = await loadingController.create({
                message: 'Please wait...',
              });
              await loading.present();

              const promises = []

              deletedhhsRecordItems.forEach(hhsRecordItem => {
                promises.push(this.deletehhsRecordItemMutation({
                  dgvPlayerId: this.selectedPerson.id,
                  scoringRecordItemId: hhsRecordItem.id,
                }))
              })


              await Promise.all(promises)
              await loading.dismiss()

              setTimeout(() => { this.$router.go() }, 400)
              //await this.findhhsRecordByPersonIdRefetch({ personId: this.selectedPerson.id });
          }}],
        });
      await alert.present();
    }
  },
  mounted() {
    if (this.selectedPerson) {
      this.findhhsRecordByPersonIdRefetch({ personId: this.selectedPerson.id }).then(res => {
      })
    }
  },
});

</script>

<style scoped>

#container {
  text-align: center;
  
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  
  color: #8c8c8c;
  
  margin: 0;
}

#container a {
  text-decoration: none;
}

section {
  margin-top: 1em;
  margin-bottom: 2.5em;
}

section:not(.full-width),
.full-width > header {
  padding: 0 10px;
}

ion-card {
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width : 100% !important;
  margin: 0 !important;
}



</style>